<template>
    <div>

        <div class="elc-login">
            <img src="/static/assets/image/login_back_ground.png">
        </div>

        <v-container>

            <v-layout row wrap>


                <v-flex xs12 md10 offset-md1>
                    <div>
                        <v-card class="p-10" style="margin: 130px 0 !important;">
                            <v-layout row wrap>

                                <v-flex xs0 sm7 md8>
                                    <v-card class="overflow-hidden text-xs-center elc-login-card">
                                        <img src="/static/assets/image/elc_background.png">
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 sm5 md4>

                                    <v-card class="elc-login-card1" v-if="loginFlag">

                                        <v-card-text>

                                            <h1 class="text-xs-center" style="color: #515a75">
                                                ELC Arvalli
                                            </h1>

                                            <v-form ref="form">

                                                <v-text-field class="p-t-20" prepend-icon="phone" label="Mobile"
                                                              :mask="mask"
                                                              v-model="phone" :rules="phoneRules"
                                                              @keyup.enter="checkEnter">
                                                </v-text-field>

                                                <v-text-field class="p-t-20" prepend-icon="lock" label="Password"
                                                              id="password"
                                                              type="password" v-model="password"
                                                              :rules="passwordRules" @keyup.enter="checkEnter">
                                                </v-text-field>

                                                <v-spacer></v-spacer>

                                                <v-card-actions>
                                                    <v-btn large block class="elc-button-radius-color m-t-20 m-b-20"
                                                           v-on:click="submit">Login
                                                    </v-btn>
                                                </v-card-actions>

                                            </v-form>

                                            <div>
                                                <p class="elc-pwd">Forgot password ? <a @click="forgotPwd">click
                                                    here</a>
                                                </p>
                                            </div>

                                            <div v-if="error.length > 0 ">
                                                <ul style="color: red">
                                                    <li v-for="message in error">{{message}}</li>
                                                </ul>
                                            </div>

                                        </v-card-text>
                                    </v-card>

                                    <v-card class="elc-login-card1" v-if="fpFlag">

                                        <v-card-text>

                                            <h1 class="text-xs-center" style="color: #515a75">
                                                Forgot Password ?
                                            </h1>

                                            <div class="v-form">
                                                <v-text-field class="p-t-20 " prepend-icon="phone"
                                                              label="Phone"
                                                              :mask="mask" ref="formFP"
                                                              v-model="rpPhone" :rules="phoneRules"
                                                              @keyup.enter="generateOTP"
                                                >
                                                </v-text-field>

                                                <v-spacer></v-spacer>

                                                <v-card-actions>
                                                    <v-btn large block class="elc-button-radius-color m-t-20 m-b-20"
                                                           v-on:click="generateOTP">Submit
                                                    </v-btn>
                                                </v-card-actions>

                                            </div>

                                            <div>
                                                <p class="elc-pwd">Sign in<a @click="afterResetLoginFP"> Here </a></p>
                                            </div>

                                            <div v-if="error.length > 0 ">
                                                <ul style="color: red">
                                                    <li v-for="message in error">{{message}}</li>
                                                </ul>
                                            </div>

                                        </v-card-text>
                                    </v-card>

                                    <v-card class="elc-login-card1" v-if="vOTPFlag">

                                        <v-card-text>

                                            <h1 class="text-xs-center" style="color: #515a75">
                                                Enter OTP
                                            </h1>

                                            <div class="v-form">

                                                <v-text-field class="p-t-20" label="OTP" ref="otp"
                                                              v-model="otp" :rules="fieldRules" @keyup.enter="verifyOTP"
                                                >
                                                </v-text-field>

                                                <v-spacer></v-spacer>

                                                <v-card-actions>
                                                    <v-btn large block class="elc-button-radius-color m-t-20 m-b-20"
                                                           v-on:click="verifyOTP">Submit
                                                    </v-btn>
                                                </v-card-actions>
                                            </div>

                                            <div>
                                                <p class="elc-pwd">Sign in<a @click="afterResetLoginVOTP"> Here </a></p>
                                            </div>

                                            <div v-if="error.length > 0 ">
                                                <ul style="color: red">
                                                    <li v-for="message in error">{{message}}</li>
                                                </ul>
                                            </div>
                                        </v-card-text>

                                    </v-card>

                                    <v-card class="elc-login-card1" v-if="rpFlag">

                                        <v-card-text>

                                            <h1 class="text-xs-center" style="color: #515a75">
                                                Reset Password
                                            </h1>

                                            <div class="v-form">

                                                <v-text-field class="p-t-20 rp_key_enter" prepend-icon="lock"
                                                              label="New Password" ref="formRPPassword"
                                                              id="rpPassword"
                                                              type="password" v-model="rpPassword"
                                                              :rules="passwordRules"
                                                              @keyup.enter="resetNewPassword">
                                                </v-text-field>

                                                <v-text-field class="p-t-20 rp_key_enter" prepend-icon="lock"
                                                              label="Confirm Password" ref="formRPConfirmPassword"
                                                              id="rpConfirmPassword"
                                                              type="password" v-model="rpConfirmPassword"
                                                              :rules="passwordRules"
                                                              @keyup.enter="resetNewPassword">
                                                </v-text-field>

                                                <v-spacer></v-spacer>

                                                <v-card-actions>
                                                    <v-btn large block class="elc-button-radius-color m-t-20 m-b-20"
                                                           v-on:click="resetNewPassword">
                                                        Submit
                                                    </v-btn>
                                                </v-card-actions>

                                            </div>

                                            <div>
                                                <p class="elc-pwd">Sign in<a @click="afterResetLoginRP"> Here</a></p>
                                            </div>

                                            <div v-if="error.length > 0 ">
                                                <ul style="color: red">
                                                    <li v-for="message in error">{{message}}</li>
                                                </ul>
                                            </div>
                                        </v-card-text>

                                    </v-card>

                                </v-flex>
                            </v-layout>
                        </v-card>
                    </div>
                </v-flex>
            </v-layout>

        </v-container>
    </div>

</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
    import VueSession from 'vue-session'
    import Common from '../Common/Constants'

    Vue.use(VueSession);
    export default {
        name: 'Login',
        data: () => ({
            constant: Common,
            mask: '##### #####',
            otp: '',
            phone: '',
            password: '',
            rpPhone: '',
            rpPassword: '',
            rpConfirmPassword: '',
            rpOtp: '',
            fpFlag: false,
            rpFlag: false,
            loginFlag: true,
            vOTPFlag: false,
            phoneRules: [
                v => !!v || 'Phone number is required',
            ], fieldRules: [
                v => !!v || 'This field is required',
            ],

            passwordRules: [
                v => !!v || 'Password is required',
                (v) => {
                    if (!v || v.length <= 4)
                        return 'Password must be greater than 4 characters'
                    else return true;
                },
            ],
            header: {
                "Content-Type": "application/json",
                "token": "",
            },
            error: [],
            otp_id: [],
            otpData: [], clubId: '', user: {}, headerClub: {}, role: '',
            successToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'success-toast'
            },

        }),
        created: function () {
            let self = this;
            let club_id = '';
            let token = localStorage.getItem('token');
            self.headerClub = {
                "Content-Type": "application/json",
                "token": token,
            };
            if (token == '' || token == undefined || token == null) {
                self.$router.push('/')
            }
            else {
                self.role = localStorage.getItem('role');
                if (self.role === '0') {
                    self.$router.push('/myclubs/district/taluka/club')
                    /*club_id = JSON.parse(localStorage.getItem('club_details')).club_id;
                    if (club_id == '' || club_id == undefined || club_id == null) {
                        self.$router.push('/')
                    } else
                        self.$router.push('/MemberDetails/' + club_id);*/
                } else {
                    self.$router.push('/clubcount');
                }
            }
        },
        methods: {
            getClubDetails() {
                let self = this;
                let request = {
                    "filters": {},
                    "sort": "created_at",
                    "direction": "desc",
                    "skip": 0,
                    "count": 9999
                };
                axios.post(Common.apiUrl + 'club/filter/allow', request, {
                    headers: {
                        "Content-Type": "application/json",
                        "token": localStorage.getItem('token'),
                    }
                })
                    .then(res => {
                        if (res.data.flag) {
                            localStorage.setItem('club_details', JSON.stringify(res.data.data.club[0]));
                            self.$router.push('/myclubs/district/taluka/club')
                            // window.location.href = '/';
                        }
                    })
                    .catch((handle) => {
                        // self.$toasted.show(handle, self.errorToast);
                    })

            },
            forgotPwd() {
                let self = this;
                self.rpPhone = '';
                self.error = [];
                self.$refs.form.reset();
                self.loginFlag = false;
                self.fpFlag = true;


            },
            generateOTP() {
                let self = this;
                let request = {
                    'phone': self.rpPhone
                };
                axios.post(Common.apiUrl + "sendOtp", request, {headers: self.header})
                    .then(function (response) {
                        if (response.data.flag) {
                            self.otp_id = [];
                            self.otp_id = response.data.data;
                            self.error = [];
                            self.otp = '';
                            self.fpFlag = false;
                            self.vOTPFlag = true;
                            self.$refs.formFP.reset()
                        } else {
                            self.error = [];
                            self.error.push("Phone number not found.");
                        }
                    });

            },
            verifyOTP() {
                let self = this;
                let request = {
                    'otp': self.otp,
                    'otp_id': self.otp_id
                };
                axios.post(Common.apiUrl + "verifyOTP", request, {headers: self.header})
                    .then(function (response) {
                        if (response.data.flag) {
                            self.otpData = [];
                            self.otpData = response.data.data;
                            self.error = [];
                            self.vOTPFlag = false;
                            self.rpFlag = true;
                            self.$refs.otp.reset();
                        } else {
                            self.$refs.otp.reset();
                            self.error = [];
                            self.error.push("OTP not matched, please try again");
                        }

                    });
            },
            resetNewPassword() {
                let self = this;
                if (self.rpConfirmPassword === self.rpPassword) {
                    let request = {
                        "password": self.rpConfirmPassword,
                        "officer_id": self.otpData.officer_id,
                        "otp_id": self.otpData.otp_id
                    };
                    axios.post(Common.apiUrl + "updatePassword", request, {headers: self.header})
                        .then(function (response) {
                            if (response.data.flag) {
                                self.error = [];
                                self.$refs.formRPPassword.reset();
                                self.$refs.formRPConfirmPassword.reset();
                                self.$toasted.show("Password has been changed", self.successToast);
                                self.rpFlag = false;
                                self.loginFlag = true
                            }

                        });
                } else {
                    self.error = [];
                    self.error.push("New Password and Confirm Password not matched, please try again.");
                }

            },
            afterResetLogin() {
                let self = this;
                self.error = [];
                self.$refs.formRPPassword.reset();
                self.$refs.formRPConfirmPassword.reset();

                let changePwd = document.getElementById("changePwd");
                changePwd.classList.add("hide_resetCard");
                changePwd.classList.remove("show_resetCard");

                let forgotPwd = document.getElementById("forgotPwd");
                forgotPwd.classList.add("hide_resetCard");
                forgotPwd.classList.remove("show_resetCard");

                let login = document.getElementById("login");
                login.classList.remove("hide_resetCard");
                login.classList.add("show_resetCard");
            },
            afterResetLoginFP() {
                let self = this;
                self.error = [];
                self.$refs.formFP.reset();

                self.fpFlag = false;
                self.rpFlag = false;
                self.loginFlag = true;
            }, afterResetLoginVOTP() {
                let self = this;
                self.error = [];
                self.$refs.otp.reset();

                self.vOTPFlag = false;
                self.rpFlag = false;
                self.loginFlag = true;
            },
            afterResetLoginRP() {
                let self = this;
                self.error = [];

                self.$refs.formRPPassword.reset();
                self.$refs.formRPConfirmPassword.reset();
                self.fpFlag = false;
                self.rpFlag = false;
                self.loginFlag = true;

            },
            submit() {
                let self = this;
                let flag = false;
                self.error = [];
                if (self.phone == '') {
                    self.error.push("Please enter phone number");
                    flag = true;
                }
                if (self.password == '') {
                    self.error.push("Please enter password");
                    flag = true;
                }
                let request = {
                    "password": self.password,
                    "phone": self.phone
                };
                if (!flag) {
                    axios.post(Common.apiUrl + "officer/login", request, self.header)
                        .then(function (response) {
                            console.log("login", response);
                            if (response.data.flag) {
                                self.$session.start();
                                self.$session.set('token', response.data.data.token);
                                localStorage.setItem('token', response.data.data.token);
                                self.$session.set('user', response.data.data);
                                localStorage.setItem('user', JSON.stringify(response.data.data));
                                self.$session.set('role', response.data.data.officer_role);
                                localStorage.setItem('role', response.data.data.officer_role);
                                if (localStorage.getItem('role') == '0') {
                                    self.getClubDetails();
                                } else {

                                    window.location.href = '/';
                                }
                            } else {
                                self.error = [];
                                self.error.push("Phone number or password is incorrect");
                            }
                        })
                }
            },
            checkEnter() {
                let self = this;
                self.submit();
            },
        }
    }
</script>

<style>

    .show_resetCard {
        display: block;
    }

    .hide_resetCard {
        display: none;
    }


</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue